module.exports = __webpack_public_path__ + "static/media/suite8.52104f08.png";